import { DialogActions, styled } from "@mui/material";
import { surface } from "@/theme";

interface ModalActionsProps {
  split?: boolean;
}

/** Canonical dialog action inset and spacing. */
export const ModalActions = styled(DialogActions, {
  shouldForwardProp: prop => prop !== "split",
})<ModalActionsProps>(({ theme, split = false }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: split ? "space-between" : "flex-end",
  flexWrap: "wrap",
  gap: theme.spacing(2),
  padding: surface.padding,
  [theme.breakpoints.down("md")]: {
    padding: surface.paddingCompact,
  },
}));
